import React from 'react';
import { PageWrapper } from '../styles';
import { Loader } from './styles';

function LoaderPage() {
  return (
    <PageWrapper>
      <Loader />
    </PageWrapper>
  );
}

export default LoaderPage;
